var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16.5264C21.25 17.2486 17.0946 21.1562 11.9688 21.1562C6.84286 21.1562 2.6875 17.2486 2.6875 16.5264C2.6875 15.8042 6.84286 15.2188 11.9688 15.2188C17.0946 15.2188 21.25 15.8042 21.25 16.5264Z",
    fill: "#3E4145"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6875,
    y: 10.1562,
    width: 18.5625,
    height: 6.4375,
    fill: "#3E4145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6574 2.94702C11.8913 2.82374 12.171 2.82403 12.4047 2.94777L23.3711 8.75511C23.9411 9.05694 23.9379 9.87454 23.3657 10.172L12.3993 15.8712C12.1685 15.9912 11.8939 15.9914 11.6629 15.872L0.642422 10.1727C0.0682413 9.87575 0.0650828 9.0557 0.636959 8.75434L11.6574 2.94702Z",
    fill: "#555960"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 9.5625L17.6562 12.6562V18.2188",
    stroke: "#FFDF4E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1547 17.73C17.3917 17.3699 17.9199 17.3699 18.157 17.73L18.607 18.4136C18.6399 18.4636 18.6801 18.5084 18.7263 18.5465L19.4537 19.1465C19.7446 19.3865 19.7446 19.8322 19.4537 20.0722L18.7263 20.6722C18.6801 20.7103 18.6399 20.7551 18.607 20.8051L18.157 21.4887C17.9199 21.8488 17.3917 21.8488 17.1547 21.4887L16.7047 20.8051C16.6718 20.7551 16.6315 20.7103 16.5853 20.6722L15.858 20.0722C15.567 19.8322 15.567 19.3865 15.858 19.1465L16.5853 18.5465C16.6315 18.5084 16.6718 18.4636 16.7047 18.4136L17.1547 17.73Z",
    fill: "#FFD61D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/GraduationCap.17d5789cabef5e75ddf03e619480e198.svg";
export { ForwardRef as ReactComponent };